(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-chocolate"] && !Shopify.designMode) return;
  try {
    
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
  
      hide() {
        super.hide();
        window.pauseAllMedia();
      }
  
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
  
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
  
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
  
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }
  
    customElements.define('product-modal', ProductModal);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-chocolate2"] && !Shopify.designMode) return;
  try {
    
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
  
      hide() {
        super.hide();
        window.pauseAllMedia();
      }
  
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
  
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
  
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
  
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }
  
    customElements.define('product-modal', ProductModal);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-colostrum2"] && !Shopify.designMode) return;
  try {
    
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
  
      hide() {
        super.hide();
        window.pauseAllMedia();
      }
  
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
  
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
  
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
  
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }
  
    customElements.define('product-modal', ProductModal);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-colostrumm"] && !Shopify.designMode) return;
  try {
    
    
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
  
      hide() {
        super.hide();
        window.pauseAllMedia();
      }
  
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }
  
      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
  
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
  
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    }
  
    customElements.define('product-modal', ProductModal);
  
  
  } catch(e) { console.error(e); }
})();
})();
